export enum DriverCommentarySelect {
  driver = 'driver',
  commentary = 'commentary',
  both = 'driverAndCommentary'
}